import { Button, Col, Row } from 'antd';
import classNames from 'classnames/bind';
import { objTypeAndClassTypeMap } from 'config/app.config';
import React from 'react';
import { Panel } from 'components/ui/index';
import { injectIntl } from 'react-intl';
import { toTimezone } from 'utils/dateTimeUtils';
import { Link, withRouter } from 'react-router-dom';
import styles from './index.less';

const cx = classNames.bind(styles);

class OpenActivity extends React.Component {
  getStatus(statusCode) {
    const { taskStatus } = this.props;
    const s = _.find(taskStatus, { id: statusCode });
    if (!_.isEmpty(s)) return s.display_value;
    return '';
  }

  render() {
    const {
      intl,
      history,
      setRouteInfo,
      activities,
    } = this.props;
    const { formatMessage } = intl;
    const rightActions = (
      <Button
        key="addBtn"
        className={`ml-sm panelBtn ${cx('text-btn')}`}
        size="small"
        onClick={() => {
          history.push('/Task');
          setRouteInfo('dashboard');
        }}
      >
        { formatMessage({ id: 'global.ui.button.viewAll' })}
      </Button>
    );

    return (
      <Row>
        <Col className="gutter-row" span={24} >
          <Panel panelTitle={formatMessage({ id: 'page.dashboard.openActivity' })} panelClasses="creamyWhite-header-panel" actionsRight={rightActions}>
            <table className={cx('task-table')}>
              <thead>
                <tr>
                  <th className={cx('task-th')}>{formatMessage({ id: 'page.dashboard.subject' })}</th>
                  <th className={cx('task-th')}>{formatMessage({ id: 'page.dashboard.name' })}</th>
                  <th className={cx('task-th')}>{formatMessage({ id: 'page.dashboard.dueDate' })}</th>
                  <th className={cx('task-th')}>{formatMessage({ id: 'page.dashboard.status' })}</th>
                </tr>
              </thead>
              <tbody>
                {activities.map(a => (
                  <tr key={a.id} className={cx('task-tr')}>
                    <td className={cx('task-td')}>
                      {a.relate_user ? (
                        <Link
                          className="text-bolder"
                          to={`/${a.taskable_type}/${a.relate_user.id}/tasks/${a.id}`}
                        >
                          {a.subject}
                        </Link>
                            ) : a.subject
                            }
                    </td>
                    <td className={cx('task-td')}>
                      {a.relate_user ? (
                        <Link to={`${a.taskable_type}/${a.relate_user.id}`}>
                          <span className={`${objTypeAndClassTypeMap[a.taskable_type]}-theme-text`}>
                            {a.relate_user.name}
                          </span>
                        </Link>
                        ) : <span className={`${objTypeAndClassTypeMap[a.taskable_type]}-theme-text`}>-</span>}
                    </td>
                    <td className={cx('task-td')}>
                      <span className={cx('text2')}>
                        {toTimezone(a.due_date)}
                      </span>
                    </td>
                    <td className={cx('task-td')}>
                      { this.getStatus(a.status_code) }
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Panel>
        </Col>
      </Row>
    );
  }
}

export default withRouter(injectIntl(OpenActivity));



// WEBPACK FOOTER //
// ./src/views/Dashboard/components/openActivity/index.jsx